export default {
	notification_health: 'صحة الإشعارات',
	notification_health_summary: 'ملخص',
	notification_health_loading: 'جارٍ التحقق من صحة الإشعارات...',
	notification_health_refresh: 'تحديث',
	notification_health_fix: 'ما يجب فعله',
	notification_health_unavailable: 'تعذّر تحميل صحة الإشعارات',
	notification_health_healthy: 'سليم',
	notification_health_blocked: 'محظور',
	notification_health_degraded: 'يحتاج إلى اهتمام',
	notification_health_no_app_user: 'لا يوجد تسجيل دخول للتطبيق',
	notification_health_unknown: 'غير معروف',
	notification_health_app_version: 'إصدار التطبيق',
	notification_health_last_delivery: 'آخر تسليم',
	notification_health_time_just_now: 'الآن',
	notification_health_time_minutes: 'منذ {count} دقيقة',
	notification_health_time_hours: 'منذ {count} ساعة',
	notification_health_time_days: 'منذ {count} يوم',
	notification_health_time_unknown: 'غير معروف',
	notification_health_summary_healthy: 'يجب أن تعمل الإشعارات',
	notification_health_summary_no_app_user: 'لم يسجّل عامل النظافة الدخول إلى التطبيق المحمول',
	notification_health_summary_blocked_no_token: 'رمز الدفع مفقود — يجب على عامل النظافة فتح التطبيق وتسجيل الدخول',
	notification_health_summary_blocked_off: 'الإشعارات معطّلة في التطبيق',
	notification_health_check_portal_contact_label: 'جهة الاتصال موجودة في البوابة',
	notification_health_check_portal_active_label: 'جهة الاتصال نشطة',
	notification_health_check_portal_rooms_label: 'الغرف المعيّنة',
	notification_health_check_portal_shifts_label: 'الورديات المعيّنة',
	notification_health_check_app_user_label: 'مسجّل الدخول في التطبيق المحمول',
	notification_health_check_push_token_label: 'رمز الدفع مسجّل',
	notification_health_check_notification_mode_label: 'وضع الإشعارات',
	notification_health_check_time_schedule_label: 'ضمن نافذة وقت الإشعارات',
	notification_health_check_ios_geo_filter_label: 'مرشّح الموقع iOS',
	notification_health_check_recent_push_attempt_label: 'محاولة دفع حديثة (48 ساعة)',
	notification_health_check_last_push_ignored_label: 'لم يُرسَل آخر إشارة',
	notification_health_check_recent_push_delivered_label: 'تم تسليم الدفع حديثاً (48 ساعة)',
	notification_health_detail_portal_contact_found: 'موجود في البوابة',
	notification_health_detail_portal_contact_missing: 'لم يُعثر على سجل جهة اتصال',
	notification_health_detail_portal_active_active: 'نشط',
	notification_health_detail_portal_active_inactive: 'غير نشط',
	notification_health_detail_portal_rooms_assigned: '{count} غرفة',
	notification_health_detail_portal_rooms_none: 'لا توجد غرف معيّنة',
	notification_health_detail_portal_shifts_assigned: '{count} وردية',
	notification_health_detail_portal_shifts_none: 'لا توجد ورديات معيّنة',
	notification_health_detail_app_user_logged_in: 'إصدار التطبيق {version}، آخر مزامنة {lastSync}',
	notification_health_detail_app_user_never: 'لم يسجّل الدخول أبداً',
	notification_health_detail_push_token_present: 'رمز FCM موجود',
	notification_health_detail_push_token_empty: 'الرمز فارغ',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'الوقت الحالي ضمن الجدول',
	notification_health_detail_time_schedule_outside: 'الوقت الحالي خارج الجدول المُعد',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'لا توجد محاولات دفع خلال آخر 48 ساعة',
	notification_health_detail_last_push_ignored: 'تم تجاهل آخر طلب دفع (servik غير مُعدّ لمنطقة العمل)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'لا توجد عمليات تسليم ناجحة خلال آخر 48 ساعة',
	notification_health_fix_portal_contact: 'أنشئ هذا عامل النظافة في لوحة المستخدمين',
	notification_health_fix_portal_active: 'فعّل مفتاح النشط لهذا العامل',
	notification_health_fix_portal_rooms: 'عيّن غرفة واحدة على الأقل لهذا العامل',
	notification_health_fix_portal_shifts: 'عيّن وردية واحدة على الأقل',
	notification_health_fix_app_user: 'يجب على عامل النظافة تثبيت التطبيق وتسجيل الدخول بهذا الرقم',
	notification_health_fix_push_token: 'اطلب من العامل فتح التطبيق والسماح بالإشعارات في إعدادات iOS وتسجيل الدخول مجدداً',
	notification_health_fix_notification_mode: 'غيّر وضع الإشعارات من إيقاف إلى دائماً في التطبيق',
	notification_health_fix_time_schedule: 'انتظر حتى النافذة المجدولة أو غيّر الوضع إلى دائماً',
	notification_health_fix_ios_geo_filter: 'العامل خارج منطقة الإشعارات — اطلب منه فتح التطبيق في الموقع',
	notification_health_fix_last_push_ignored: 'تحقق من إعداد servik لمنطقة العمل للغرفة التي أطلقت الإشارة',
	notification_health_fix_recent_push_delivered_filters: 'تحقق من مرشّحات الإشعارات أو إعدادات الجهاز',
	notification_health_fix_recent_push_delivered_token: 'سجّل رمز الدفع أولاً',
	notification_health_mode_on: 'دائماً',
	notification_health_mode_off: 'إيقاف',
	notification_health_mode_time: 'حسب الوقت',
	notification_health_mode_location: 'حسب الموقع',
	notification_health_filter_on: 'تشغيل',
	notification_health_filter_off: 'إيقاف',
};
